import { useEffect, useState } from 'react';

import { api, CareServiceReportOrgansStructure } from '@/api';

import { useStudyGuard } from '../study-guard';

interface UseCareServiceReportOrgansResult {
  data: null | Partial<CareServiceReportOrgansStructure>;
  isLoading: boolean;
}

export function useCareServiceReportOrgans(): UseCareServiceReportOrgansResult {
  const {
    radiologistScan: { poetryMetadata },
    studyId,
  } = useStudyGuard();

  const [postData, setPostData] = useState<CareServiceReportOrgansStructure | null>(null);

  const postMutation = api.fct.careServiceReportOrgans.mutation.usePostCareServiceReportOrgans();

  const {
    data: getData,
    error,
    isError,
    isLoading: isGetLoading,
  } = api.fct.careServiceReportOrgans.query.useGetCareServiceReportOrgans(
    { payload: { studyId } },
    { enabled: !!studyId },
  );

  const is404 = isError && error?.response?.status === 404;

  useEffect(() => {
    if (is404 && postMutation.isIdle) {
      postMutation.mutate(
        {
          payload: {
            carePlanServices: (poetryMetadata?.servicesInfo ?? []).map((service) => service.code),
            studyUuid: studyId,
          },
        },
        {
          onSuccess: (data) => setPostData(data),
        },
      );
    }
  }, [is404, studyId, poetryMetadata, postMutation]);

  const isLoading = isGetLoading || postMutation.isPending || (is404 && postMutation.isIdle);
  const data = getData || postData;

  return {
    data,
    isLoading,
  };
}
